import { createStyles } from "@material-ui/core";
import { getTheme } from "../../Themes";

const theme = getTheme();

export default createStyles({
  nested: {
    paddingLeft: '30px',
  },
  datePicker: {
    display: 'flex',
    alignItems: 'flex-end',
    fontStyle: 'italic',

    color: theme.palette.text.secondary,
    fontFamily: 'sans-serif',
    marginBottom: '6px',
  },
  datePickerInput: {
    border: 'none',
    marginRight: '10px',
    background: theme.palette.background.paper,
    color: theme.palette.text.secondary,
  },
  datePickerLabel: {
    fontWeight: 100,
    color: theme.palette.text.secondary,
    textTransform: 'capitalize',
  },
  datePickerInputSmallFont: {
    '& input': {
      textAlign: 'center',
      padding: '8px 4px',
      color: theme.palette.text.secondary,
    },
  },
  drawer: {
    '&.hidden': {
      width: '0px',
    },
    flexShrink: 0,
  },
  drawerPaper: {
    width: theme.Adtrack.dimensions.drawerWidth,
    paddingTop: '14px',
    paddingLeft: '15px',
    paddingRight: '15px',
    backgroundColor: theme.palette.background.default,
    overflowX: 'hidden',
  },
  formControlLabel: {
    fontWeight: 400,
    opacity: '70%',
  },
  formControlIcon: {
    fontWeight: 100,
    opacity: '70%',
  },
  iconButton: {
    padding: 10,
  },
  inputSearch: {
    marginLeft: theme.spacing(1),
    flex: 1,
    '&:before': {
      border: 'none',
    },
  },
  lowerCase: { textTransform: 'lowercase' },
  inputLabelPropsStyle: {
    top: '-14px',
  },
  inputPropsRoot: {
    marginTop: '7px !important',
  },
  intputLabelFont: {
    color: theme.palette.text.secondary,
    opacity: 0.9,
  },
  inputPropsStyle: {
    height: '18px',
    padding: '0 14px',
  },
  opacity70: {
    opacity: '70%',
  },
  reduceSvgIconSize: {
    '& svg': {
      transform: 'scale(0.7)',
    },
  },
  rootSearch: {
    alignItems: 'center',
    display: 'flex',
    padding: '2px 0',
    '& .MuiInput-root:before': {
      border: 'none',
    },
    '& .MuiInput-underline:hover:not(.Mui-disabled):before': {
      border: 'none',
    },
    '& .MuiInput-underline:after': {
      border: 'none',
    },
  },
  tab: {
    minWidth: '45%',

    paddingTop: '0px',
    paddingBottom: '0px',
    minHeight: '50px',
    color: theme.palette.text.primary,
  },
});